// back to top button
const footerBtn = document.getElementById("footerBackToTop");

// Smooth scroll to top on click
footerBtn.addEventListener("click", () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
});
